/**
 * The ONE browser bounded-concurrency helper: runs `jobs` with at most `limit`
 * in flight and returns their results in job order. Moved unchanged from
 * `ManualLabelImportDialog` (Phase 86) so the colour artwork fan-out reuses it
 * instead of adding a second copy or a new package.
 *
 * A job that rejects rejects the whole call (like `Promise.all`); jobs already
 * started keep running. Callers that want per-job failures catch inside the job.
 */
export async function runWithConcurrency<T>(jobs: Array<() => Promise<T>>, limit: number): Promise<T[]> {
  const results: T[] = new Array(jobs.length);
  let cursor = 0;
  const runners = Array.from({ length: Math.min(limit, jobs.length) }, async () => {
    while (cursor < jobs.length) {
      const index = cursor++;
      results[index] = await jobs[index]!();
    }
  });
  await Promise.all(runners);
  return results;
}
